import { z } from 'zod'

export const trainerPlatformExceptionResponseSchema = z.record(z.unknown())
export type TrainerPlatformExceptionResponse = z.infer<typeof trainerPlatformExceptionResponseSchema>
